import { NavLink } from "react-router";
import { cx } from "./ui";

/** Every page in the Staff & roles area (Buildwise), in the order of its tabs. */
export const PEOPLE_TABS = [
  { to: "/staff", label: "Till staff" },
  { to: "/team", label: "Back office team" },
  { to: "/permissions", label: "Roles & permissions" },
];
export const isPeoplePage = (path: string) => PEOPLE_TABS.some((t) => path === t.to || path.startsWith(`${t.to}/`));

/** The tabs across the top of Staff & roles, showing only what this person can open. */
export function PeopleTabs({ allowed }: { allowed: (to: string) => boolean }) {
  return (
    <nav aria-label="Staff and roles" className="no-scrollbar mb-5 flex gap-0.5 overflow-x-auto border-b border-slate-200 print:hidden">
      {PEOPLE_TABS.filter((t) => allowed(t.to)).map((t) => (
        <NavLink key={t.to} to={t.to} className={({ isActive }) => cx("-mb-px flex h-12 flex-none items-center whitespace-nowrap border-b-[3px] px-3.5 text-sm", isActive ? "border-brand font-extrabold text-ink" : "border-transparent font-semibold text-slate-500 hover:text-ink")}>
          {t.label}
        </NavLink>
      ))}
    </nav>
  );
}
